const REPORT_TYPES = {
    2: {
        id: 2,
        description: 'afip_f8126',
        text: 'AFIP 8126',
        name: 'AFIP_8126.TXT'
    },
    3: {
        id: 3,
        description: 'bcra_finances',
        text: 'Infestadística',
        name: 'INFESTADISTICA.TXT'
    },
    6: {
        id: 6,
        description: 'bcra_accounts',
        text: 'Cuentas',
        name: 'CUENTASCLIENTES.TXT'
    },
    12: {
        id: 12,
        description: 'accounting_entries',
        text: 'Asientos contables',
        name: 'ASIENTOSCONTABLES.TXT'
    },
    16: {
        id: 16,
        description: 'afip_exempt_taxes_debits_credits',
        text: 'Afip exentos IDC',
        name: 'EXENTOSIDC.TXT'
    },
    17: {
        id: 17,
        description: 'accounts_daily_balance',
        text: 'Reporte de Saldos Diarios',
        name: 'SALDOSDIARIOS.TXT'
    },
    19: {
        id: 19,
        description: 'emails_list',
        text: 'Listado de emails',
        name: 'LISTAEMAILS.csv',
    },
    natura_journal_entries: {
        id: 40,
        description: 'journal_entries',
        text: 'Asientos contables',
        name: 'ASIENTOSCONTABLES.TXT'
    },
    users: {
        id: 58,
        description: 'users_list',
        text: 'Listado de usuarios',
        name: 'ReporteUsuarios.csv'
    },
};
export default REPORT_TYPES;
